import React from 'react';
import Icon from '../Icon';
import { UspSign } from './FooterSign';

interface UspItemProps {
  text: string;
}

const UspItem = ({ text }: UspItemProps) => {
  return (
    <div className="text-white text-lg leading-[2.4rem] gap-1 flex items-center">
      <Icon name="usp_check" className="w-6 h-6 flex-shrink-0" />
      {text}
    </div>
  );
};

export const Usp = ({ header, lines }: FooterUsp) => {
  const items = lines.map((line, idx) => {
    return <UspItem key={idx} text={line} />;
  });

  return (
    <div className="lg:mb-16 mb-8">
      <div className="container">
        <div className="text-white uppercase mb-4 md:mb-6 display-4 lg:mt-12 mt-8">
          {header}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-x-6 gap-y-6 md:gap-y-8">
          <div className="grid md:grid-cols-2 grid-cols-1 gap-x-6 gap-y-2 md:col-span-2">
            {items}
          </div>
          <div className="2xl:col-start-4 xl:col-span-1">
            <UspSign />
          </div>
        </div>
      </div>
    </div>
  );
};
